export type SignUpStepTwoViewProps = {
  email?: string;
};

export const defaultProps = {
  email: '',
};
